module.exports = __webpack_public_path__ + "img/IMG_2493_L.2e597c6d.webp";